
class ShippingDateComponents extends HTMLElement {
  constructor() {
    super();

    this.today = new Date();
    this.targetDate = new Date(this.today.getTime() + (2 * 24 * 60 * 60 * 1000));

    // Check if targetDate is a Saturday or Sunday, and adjust accordingly
    if (this.targetDate.getDay() === 6) { // Saturday
      this.targetDate.setDate(this.targetDate.getDate() + 2);
    } else if (this.targetDate.getDay() === 0) { // Sunday
      this.targetDate.setDate(this.targetDate.getDate() + 1);
    }
  
    // Skip weekends until a weekday is reached
    while (this.targetDate.getDay() === 6 || this.targetDate.getDay() === 0) {
      this.targetDate.setDate(this.targetDate.getDate() + 1);
    }

    this.day = this.targetDate.getDate();
    this.ordinal = this.getOrdinalSuffix(this.day);
    this.month = this.targetDate.toLocaleString('default', { month: 'long' });
    this.year = this.targetDate.getFullYear();

    this.innerText = `${this.month} ${this.day}${this.ordinal}`;
  }

  getOrdinalSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    } else {
      const lastDigit = day % 10;
      switch (lastDigit) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    }
  }
}

customElements.define('shipping-date', ShippingDateComponents);


jQuery(document).ready(function () {
  jQuery(".compare-btn").on("click", function (e) {
    const productId = jQuery(this).data("product-id");  
    console.log(productId);
      if (!productId) return;
    // Set the product ID as the new value in the cookie
    setCookie("compare_products", productId, 7);
    const compare_product = jQuery(this).data("products");
      if(!compare_product) return;
    setCookie('product_id', compare_product, 7);
  });
});

// Function to set a cookie
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000)); // Expiry date in days

  // Ensure SameSite and Secure attributes are set
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`;
}

function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }





